import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ActivityStore } from 'src/app/stores/resources/activity.store';
import { DataService } from 'src/app/services/data.service';
import { pushObjArray } from 'src/app/services/convert.service';

@Component({
  selector: 'app-add-picture-question',
  templateUrl: './add-picture-question.component.html',
  styleUrls: ['./add-picture-question.component.scss']
})
export class AddPictureQuestionComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  form: FormGroup;
  answer: AbstractControl;
  isCorrect: AbstractControl;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;
  TITLE = 'Add new option';

  constructor(
    public dialogRef: MatDialogRef<AddPictureQuestionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public store: ActivityStore,
    private ds: DataService,
  ) { }

  ngOnInit() {
    const { ANSWER } = this.data;
    this.form = this.fb.group({
      answer: [ANSWER ? ANSWER.name : null, Validators.compose([Validators.required])],
      isCorrect: [ANSWER ? ANSWER.isCorrect : false],
      answerTip: [ANSWER ? ANSWER.answerTip : null]
    })
    if (ANSWER) {
      this.TITLE = "Edit option";
    }
  }

  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    this.error = null;
    if (this.form.valid) {
      const { answer, isCorrect, answerTip } = f;
      const { ANSWER } = this.data;
      const answers = this.store.options
      const row = {
        key: ANSWER ? ANSWER.key : this.ds.createId(),
        name: `${answer}`,
        isCorrect: isCorrect || false,
        answerTip: answerTip || null,
      };
      const options = pushObjArray(answers, row)
      this.store.options = options;
      this.form.reset();
      this.inputEl.nativeElement.focus();
      if (!isNew) {
        this.dialogRef.close('yes')
      }
      if (ANSWER) {
        this.dialogRef.close('yes')
      }
    }
  }
}